export default "__VITE_ASSET__BXCo7DrI__"